export default {
  Title: 'List of Requests',
  Domain: 'Domain',
  Types: 'Types',
  Source: 'Source',
  SaleRevenue: 'Sales Revenue',
  PartnerProceeds: 'Partner Proceeds',
  MisaProceeds: 'MISA Proceeds',
  Upgrade: 'Upgrade',
  Extend: 'Extend',
  PurchaseDevice: 'Purchase devices',
  NeedApproval: 'Need Approval',
  Rejected: 'Rejected',
  Approved: 'Approved',
  By: 'by ',
  Approve: 'Approve',
  Edit: 'Edit',
  Delete: 'Delete',
  Search: 'Search',
  Filter: 'Filter',
  Type: 'Type',
  PurchaseExtraDevices: 'Purchase extra devices',
  Status: 'Status',
  All: 'All',
  DateCreated: 'Created date',
  Createby: 'Created by',
  Clear: 'Clear',
  Cancel: 'Cancel',
  Apply: 'Apply',
  Total: 'Total: {number} requests',
  TotalRange: 'requests',
  ApproveRequest: 'Approved Request',
  ApproveRequestText: 'Are you sure you want to approve this request?',
  Success: 'Update successfully',
  SuccessFail: 'Update failed',
  OtherReason: 'Orther reasons',
  AcceptDelete: 'Are you sure delete this request?',
  Failed: 'An error occurred, please try again',
  Partner: 'Partner',
  DeleteSuccess: 'Delete successfully'
};